import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'je-admin-frame',
  templateUrl: './admin-frame.component.html',
  styleUrls: ['./admin-frame.component.scss']
})
export class AdminFrameComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
